export class CategoryModel {
    category_no: number
    category_name: string
    category_code: string
    parent_category: number

    constructor(
        category_no: number,
        category_name: string,
        category_code: string,
        parent_category: number
    ) {
        this.category_no = category_no
        this.category_name = category_name
        this.category_code = category_code
        this.parent_category = parent_category
    }
}